import { createAsyncThunk } from '@reduxjs/toolkit'
import { getTaxesUrl } from '@services'

export const fetchTaxesUrl = createAsyncThunk<string, void>(
  'fetchTaxesUrl',
  async () => getTaxesUrl(),
)
